import React from "react";
import { DateTime } from "luxon";
import { UseCases } from "@planzone/core";
import { useModal } from "@root/client/modal";
import { usePlanzonePermissions } from "@components/permissions";
import classNames from "classnames";
import { Props } from "./types";
import styles from "./styles.scss";

function Unavailability({ unavailability }: Props) {
  const { isAdministrator } = usePlanzonePermissions();
  const { pushView } = useModal();
  const userTimezone = DateTime.local().zoneName;
  const startDt = DateTime.fromISO(unavailability.startDate, {
    zone: "utc",
  }).setZone(userTimezone);
  const endDt = DateTime.fromISO(
    unavailability.endDate || unavailability.startDate,
    { zone: "utc" },
  ).setZone(userTimezone);
  const startLabel = startDt.isValid
    ? startDt.toLocaleString({ hour: "2-digit", minute: "2-digit" })
    : "—";
  const endLabel = endDt.isValid
    ? endDt.toLocaleString({ hour: "2-digit", minute: "2-digit" })
    : "—";
  const isShort =
    startDt.isValid &&
    endDt.isValid &&
    endDt.toMillis() - startDt.toMillis() <= 30 * 60 * 1000;

  return (
    <div
      className={styles.unavailability}
      onClick={() =>
        pushView({ data: unavailability, key: UseCases.editUnavailability })
      }
    >
      <div className={styles.background} />
      <div className={styles.leftBorder} />
      <div className={classNames(styles.main, { [styles.short]: isShort })}>
        <p className={styles.time}>
          {startLabel} - {endLabel}
        </p>
        <p className={styles.name}>
          {isAdministrator ? `[${unavailability.resource.name}] ` : ""}
          {unavailability.label}
        </p>
      </div>
    </div>
  );
}

export { Unavailability };
